var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 271,
    height: 161,
    viewBox: "0 0 271 161",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1024_2061)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M256.604 39.692C263.801 61.212 215.178 96.8699 148.002 119.336C80.8258 141.802 20.5343 142.569 13.3373 121.049C6.14019 99.5292 54.7629 63.8713 121.939 41.4051C189.115 18.939 249.407 18.1719 256.604 39.692Z",
    stroke: "#B5FF5B",
    strokeWidth: 0.539768,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.971 53.9498C221.168 75.4699 191.633 104.744 148.002 119.336C104.371 133.928 63.167 128.311 55.9699 106.791C48.7729 85.2711 78.3082 55.9968 121.939 41.405C165.57 26.8133 206.774 32.4298 213.971 53.9498Z",
    stroke: "#B5FF5B",
    strokeWidth: 0.539768,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.604 39.6919L13.3371 121.049",
    stroke: "#B5FF5B",
    strokeWidth: 0.539768,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.617 66.777C182.814 88.2971 170.45 111.829 148.002 119.336C125.554 126.844 101.521 115.484 94.3242 93.9642C87.1272 72.4442 99.4907 48.9127 121.939 41.4052C144.387 33.8976 168.42 45.257 175.617 66.777Z",
    fill: "#B5FF5B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.961 72.3474C163.209 85.0484 155.911 98.9368 142.662 103.368C129.412 107.799 115.228 101.095 110.98 88.394C106.732 75.693 114.03 61.8046 127.279 57.3734C140.529 52.9423 154.713 59.6464 158.961 72.3474Z",
    fill: "#11120D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.504 71.8405C131.929 76.1023 129.493 80.7584 125.062 82.2402C120.632 83.7219 115.884 81.4682 114.459 77.2064C113.034 72.9446 115.47 68.2885 119.901 66.8068C124.331 65.325 129.078 67.5787 130.504 71.8405Z",
    fill: "#B5FF5B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1024_2061"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 82.657,
    height: 257.075,
    fill: "white",
    transform: "matrix(0.317169 0.948369 0.948369 -0.317169 -0.00012207 81.9312)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenEye);
export default __webpack_public_path__ + "static/media/greenEye.203228263feffe3cbf233764849accd4.svg";
export { ForwardRef as ReactComponent };